/* eslint-disable @tencent/i18next/no-literal-string */
import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_INSERT_DOC } from '@editor/src/img/pageIndex';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

export const config = {
    id: ActionType.INSERT_TENCENT_DOC_ID,
    content: TENANT_CONFIG.TENANT_DOC_NAME ?? i18n.t('腾讯文档'),
    icon: TENANT_CONFIG.TENANT_LOGO.SVG_BLACK ?? TOOLBAR_INSERT_DOC,
    tooltip: TENANT_CONFIG.TENANT_DOC_NAME ? `插入${TENANT_CONFIG.TENANT_DOC_NAME}` : i18n.t('插入腾讯文档'),
};

export const INSERT_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''} />,
        tooltip: config.tooltip,
        respectOffline: true,
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tooltip,
        text: config.content,
        icon: <img src={config.icon} alt={''} />,
        respectOffline: true,
    },
];
